import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueCountryCode from "vue-country-code";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Tooltip from "v-tooltip";
import 'material-design-icons/iconfont/material-icons.css';
// import VueTelInput from 'vue-tel-input'
// import 'vue-tel-input/dist-modern/css';

// import VueTelInput from 'vue-tel-input';
// import 'vue-tel-input/vue-tel-input.css';
// import 'vue-tel-input/dist/vue-tel-input.css';

import {
  faUserPlus,
  faUser,
  faUserSecret,
  faExchangeAlt,
  faArrowUp,
  faArrowLeft,
  faComment,
  faCommentSlash,
  faLevelUpAlt,
  faCompress,
  faTimes,
  faPlay,
  faExternalLinkAlt,
  faChevronDown,
  faChevronLeft,
  faAddressBook,
  faCog,
  faPlus,
  faPhone,
  faPhoneSlash,
  faPhoneAlt,
  faTh,
  faCaretDown,
  faMicrophoneAlt,
  faMicrophoneAltSlash,
  faPause,
  faRandom,
  faArrowDown,
  faStickyNote,
  faMoneyCheckAlt,
  faHandsHelping,
  faAddressCard,
  faList,
  faBook,
  faInfo,
  faWindowClose,
  faRetweet,
  faBackspace
} from "@fortawesome/free-solid-svg-icons";

// Vuetify
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'

// const vuetify = createVuetify({
//   components,
//   directives,
// })
// Vue.use(vuetify)

Vue.use(VueCountryCode);
// Vue.use(VueTelInput)
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(Tooltip);
library.add(
  faUserPlus,
  faArrowDown,
  faArrowUp,
  faLevelUpAlt,
  faComment,
  faCommentSlash,
  faUser,
  faUserSecret,
  faExchangeAlt,
  faCompress,
  faPlay,
  faTimes,
  faChevronDown,
  faExternalLinkAlt,
  faChevronLeft,
  faArrowLeft,
  faAddressBook,
  faCog,
  faPhone,
  faPlus,
  faPhoneSlash,
  faPhoneAlt,
  faTh,
  faCaretDown,
  faMicrophoneAlt,
  faMicrophoneAltSlash,
  faPause,
  faRandom,
  faStickyNote,
  faMoneyCheckAlt,
  faHandsHelping,
  faAddressCard,
  faList,
  faBook,
  faInfo,
  faWindowClose,
  faRetweet,
  faBackspace
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  store,
  render: (h) => h(App),
}).$mount("#app");
